import React, { Component } from 'react';
import { Link, } from 'react-router-dom';
import { connect, } from 'react-redux';
import { withRouter } from '../withRouter';

import styles from "components/Layout/FooterStyles.module.scss";
import TrustBoxContainer from '../TrustWidget';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXTwitter, faInstagram, faFacebook, faYoutube, faTiktok, faKickstarter } from "@fortawesome/free-brands-svg-icons";
import { APP_TYPES } from '../../constants/AppTypes';
import WebIcon from "images/icons/web-icon.png";
import FireTVIcon from "images/icons/FireTV-Icon.png";
import RokuIcon from "images/icons/Roku-Icon.png";

const platforms = [
    {
        Platform: APP_TYPES.FIRE_TV,
        icon: FireTVIcon,
        link: "https://www.amazon.co.uk/Game-City-Game-City/dp/B0FCYQ3QY7/ref=sr_1_6?crid=1HYZ8KROZPE3Q&dib=eyJ2IjoiMSJ9.8FmPt9aRPWTU9EIjS4v9rBc1OzkR5g7FwwI6Bts_C4nD1Hos0s_FKTAEzgkEW5MWoFy-Z7AN9cDeW70SMLQ_JiDh_WU6x3PrH2CxLSmUbHPBgWA-UszU3foPJtC0pK2aseieTBMCVzwS2Ez2UeKVh-cjY5p_0E_fqYRG4qAfYscIMoOKn-1jKWxS-RpyIw9lgpr8JUMQaSZyq_COX2MO3SKsoyShTzZONoktuJoNTJkVJ2fcS4g_iGAU5y-Qy8g45K9Cah0IEH2EkelWFkIHmt6SKaU8FDTL3FTD90uElsk.DYEAaB96KVfdhfMuXvjklBo42TKSgftMh4AT_oE44mU&dib_tag=se&keywords=Game+City&qid=1756198594&sprefix=game+city%2Caps%2C104&sr=8-6"
    },
    {
        Platform: APP_TYPES.ROKU,
        icon: RokuIcon,
        link: "https://channelstore.roku.com/en-gb/details/f40f6c4e12bfb9b619aa4530404178ea:bf00789f9ba54a68d7fc648d46ddbfc5/game-city-party-games-on-tv"
    },
    {
        Platform: APP_TYPES.WEB,
        icon: WebIcon
    }
];


class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };

    }

    getCurrentYear() {
        const date = new Date();
        const year = date.getFullYear();
        return year;
    }

    openInNewTab(url) {
        window.open(url, '_blank').focus();
    }

    render() {
        const pathname = window.location.pathname;
        const limitAccessFireTv = this.props.room?.roomState?.platform === APP_TYPES.FIRE_TV || this.props.devices.limitAccessFireTv;
        return (
            !pathname.includes("lobby") &&
            <>
                <div className={styles.supportedPlatforms}>
                    <h3 className={styles.header}>You can find us on:</h3>
                    <div className={styles.platformsList}>
                        {
                            platforms.map(x =>
                                <div className={styles.platform}>
                                    {
                                        x.link ?
                                            <a href={x.link} target="_blank">
                                                <img src={x.icon} />
                                            </a>
                                            :
                                            <img src={x.icon} />
                                    }
                                </div>
                            )
                        }
                    </div>
                </div>
                <div className={`container-fluid ${styles.footerContainer}`}>
                    {/* Policies */}
                    <div className="container">
                        {!limitAccessFireTv &&
                            <>
                                <ul className={`${styles.linksRow}`}>
                                    <li className={styles.linkText}>
                                        <Link to="/terms">Terms & Conditions</Link>
                                    </li>
                                    <li className={styles.linkText}>
                                        <Link to="/privacy-policy">Privacy Policy</Link>
                                    </li>
                                    <li className={styles.linkText}>
                                        <Link to="/cookie-policy">Cookie Policy</Link>
                                    </li>
                                    <li className={styles.linkText}>
                                        <Link to="/data-protection">Data Protection</Link>
                                    </li>
                                </ul>
                                <div className={`${styles.socialsBar}`}>
                                    <FontAwesomeIcon icon={faKickstarter} onClick={() => this.openInNewTab("https://www.kickstarter.com/projects/1169339123/deal-or-no-deal-the-party-game-for-your-tv")} target="_blank" />
                                    <FontAwesomeIcon icon={faXTwitter} onClick={() => this.openInNewTab("https://x.com/PlayGameCity")} target="_blank" />
                                    <FontAwesomeIcon icon={faFacebook} onClick={() => this.openInNewTab("https://www.facebook.com/people/GameCity-Collective/61558537700430/")} target="_blank" />
                                    <FontAwesomeIcon icon={faInstagram} onClick={() => this.openInNewTab("https://www.instagram.com/playgame.city/")} target="_blank" />
                                    <FontAwesomeIcon icon={faTiktok} onClick={() => this.openInNewTab("https://www.tiktok.com/@gamecityplay")} target="_blank" />
                                    <FontAwesomeIcon icon={faYoutube} onClick={() => this.openInNewTab("https://www.youtube.com/channel/UCQ2umAKfPvIbsdzaJvZWaKA")} target="_blank" />
                                </div>
                            </>
                        }
                        {/*<TrustBoxContainer />*/}
                        <div style={{ clear: 'both' }}>
                        </div>
                        <div className={`pt-3 ${styles.copyrightText}`} style={{ textAlign: "center" }}>
                            &copy; {this.getCurrentYear()} The Games Collective, Ltd. All rights reserved.
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        room: state.room,
        devices: state.devices,
    };
}

export default connect(mapStateToProps)(withRouter(Footer));